module.exports = __webpack_public_path__ + "static/media/icn-bullets.c82e645b.svg";